// This file was generated by GenerateES6Bundle.
var content = {};

  // LOCALIZE THE SECOND STRING LITERAL IN THE FOLLOWING PAIRS:

  //Communication Error
  content["Communication Error"] =
  "Communication Error";

  // END OF LOCALIZATION

export default content;
